/* Loyalty page UX — Redeem Now scroll + Yotpo redeem card click bridge */
(function () {
  var ROOT_SEL = '.rb-rewards';
  var TARGET_SEL = '#rb-how-to-use-points, .rb-rewards .rewsec5, .rb-rewards .yotpo-coupons-redemption-widget';
  var REDEEM_BTN_SEL =
    '.yotpo-coupons-redemption-widget .yotpo-redemption-option-redeem-button .yotpo-button-style, ' +
    '.yotpo-coupons-redemption-widget .yotpo-redemption-option-redeem-button button.yotpo-button-style, ' +
    '.yotpo-coupons-redemption-widget .yotpo-redemption-option-container > .yotpo-redemption-option button.yotpo-button-style';
  var CONFIRM_YES_SEL =
    '.yotpo-coupons-redemption-widget .yotpo-redemption-confirmation-option-confirm .yotpo-button-style, ' +
    '.yotpo-coupons-redemption-widget .yotpo-redemption-confirmation-option-confirm button';
  var CONFIRM_NO_SEL =
    '.yotpo-coupons-redemption-widget .yotpo-redemption-confirmation-option-cancel .yotpo-button-style, ' +
    '.yotpo-coupons-redemption-widget .yotpo-redemption-confirmation-option-cancel button';

  function findRoot() {
    return document.querySelector(ROOT_SEL);
  }

  function findHowToUseTarget() {
    var root = findRoot();
    if (!root) return null;
    var byId = document.getElementById('rb-how-to-use-points');
    if (byId) return byId;
    var headlines = root.querySelectorAll(
      '.yotpo-coupons-redemption-widget .yotpo-headline, .yotpo-coupons-redemption-widget .yotpo-customized-text.yotpo-headline'
    );
    for (var i = 0; i < headlines.length; i++) {
      var t = (headlines[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/how\s+to\s+use/i.test(t) || /loyalty\s+discounts/i.test(t)) return headlines[i];
    }
    return root.querySelector(TARGET_SEL);
  }

  function scrollToHowToUse() {
    var target = findHowToUseTarget();
    if (!target) return false;
    var header = document.querySelector('.rb-header');
    var offset = header ? Math.ceil(header.getBoundingClientRect().height) + 16 : 80;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  /* Only the My Rewards "Redeem Now" CTA — never coupon-card Redeem buttons */
  function isRedeemNowControl(el) {
    if (!el || !el.closest) return null;
    if (el.closest('.yotpo-coupons-redemption-widget')) return null;
    var btn = el.closest(
      '.yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile .yotpo-button-style, ' +
        '.yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile button, ' +
        '.yotpo-widget-my-rewards-widget .yotpo-primary-button .yotpo-button-style, ' +
        '.yotpo-widget-my-rewards-widget .yotpo-primary-button button'
    );
    if (!btn) return null;
    var label = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (label === 'redeem now') return btn;
    return null;
  }

  function onRedeemNowClick(event) {
    var btn = isRedeemNowControl(event.target);
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    window.setTimeout(scrollToHowToUse, 0);
  }

  function fixRedeemSwiperClicks() {
    var root = findRoot();
    if (!root) return;
    var widget = root.querySelector('.yotpo-coupons-redemption-widget');
    if (!widget) return;
    var hosts = widget.querySelectorAll(
      '.swiper-container, .yotpo-redemption-options-carousel, .swiper'
    );
    for (var i = 0; i < hosts.length; i++) {
      var swiper = hosts[i].swiper;
      if (!swiper) continue;
      try {
        swiper.allowClick = true;
      } catch (e0) {}
      if (!swiper.params) continue;
      swiper.params.preventClicks = false;
      swiper.params.preventClicksPropagation = false;
      if (typeof swiper.allowClick !== 'undefined') swiper.allowClick = true;
    }

    var noSwipe = widget.querySelectorAll(
      '.yotpo-redemption-option-redeem-button, .yotpo-redemption-confirmation, ' +
        '.yotpo-redemption-option-container .yotpo-button-style, ' +
        '.yotpo-redemption-option-container button'
    );
    for (var n = 0; n < noSwipe.length; n++) {
      noSwipe[n].classList.add('swiper-no-swiping');
    }
  }

  function cardVmFrom(el) {
    if (!el || !el.closest) return null;
    var card = el.closest('.yotpo-redemption-option-container');
    if (!card) return null;
    var vm = card.__vue__;
    if (vm && (typeof vm.redeemButtonClicked === 'function' || typeof vm.setConfirmationActive === 'function')) {
      return vm;
    }
    var node = card;
    while (node && node !== card.parentNode) {
      if (node.__vue__) {
        vm = node.__vue__;
        while (vm) {
          if (typeof vm.redeemButtonClicked === 'function' || typeof vm.setConfirmationActive === 'function') {
            return vm;
          }
          vm = vm.$parent;
        }
      }
      node = node.firstElementChild;
      if (!node) break;
    }
    return card.__vue__ || null;
  }

  function invokeRedeem(vm) {
    if (!vm) return false;
    try {
      if (typeof vm.redeemButtonClicked === 'function') {
        vm.redeemButtonClicked(true);
      } else if (typeof vm.setConfirmationActive === 'function') {
        vm.setConfirmationActive(true);
      } else {
        return false;
      }
      if (typeof vm.$forceUpdate === 'function') vm.$forceUpdate();
      return true;
    } catch (err) {
      return false;
    }
  }

  function invokeConfirmYes(vm) {
    if (!vm) return false;
    try {
      if (typeof vm.redemptionRequest === 'function') {
        vm.redemptionRequest();
      } else if (typeof vm.setConfirmationActive === 'function') {
        /* fall through */
      } else {
        return false;
      }
      if (typeof vm.buttonClicked === 'function') {
        try {
          vm.buttonClicked('redemption_requested');
        } catch (e1) {}
      }
      if (typeof vm.$forceUpdate === 'function') vm.$forceUpdate();
      return true;
    } catch (err) {
      return false;
    }
  }

  function invokeConfirmNo(vm) {
    if (!vm) return false;
    try {
      if (typeof vm.setConfirmationActive === 'function') vm.setConfirmationActive(false);
      if (typeof vm.buttonClicked === 'function') {
        try {
          vm.buttonClicked('redeem_canceled');
        } catch (e1) {}
      }
      if (typeof vm.$forceUpdate === 'function') vm.$forceUpdate();
      return true;
    } catch (err) {
      return false;
    }
  }

  /*
    Yotpo Redeem bridge (rb-redeem-vue-bridge):
    Swiper preventClicks / allowClick=false can swallow the native button click so Vue never runs.
    Call the card Vue methods directly (same path ActionButton → redeemButtonClicked → confirmation).
  */
  function onRedeemWidgetClick(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (!t.closest('.yotpo-coupons-redemption-widget')) return;

    fixRedeemSwiperClicks();

    var yesBtn = t.closest(CONFIRM_YES_SEL);
    if (yesBtn && !yesBtn.disabled) {
      var yesVm = cardVmFrom(yesBtn);
      if (yesVm) {
        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        event.stopPropagation();
        invokeConfirmYes(yesVm);
      }
      return;
    }

    var noBtn = t.closest(CONFIRM_NO_SEL);
    if (noBtn && !noBtn.disabled) {
      var noVm = cardVmFrom(noBtn);
      if (noVm) {
        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        event.stopPropagation();
        invokeConfirmNo(noVm);
      }
      return;
    }

    var redeemBtn = t.closest(REDEEM_BTN_SEL);
    if (!redeemBtn || redeemBtn.disabled) return;
    if (redeemBtn.closest('.yotpo-redemption-confirmation')) return;

    var vm = cardVmFrom(redeemBtn);
    if (!vm) return;

    event.preventDefault();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    event.stopPropagation();
    invokeRedeem(vm);
  }

  function onRedeemTouchStart() {
    fixRedeemSwiperClicks();
  }

  function refreshRedeemLayout() {
    fixRedeemSwiperClicks();
    ensureRedeemHeadingFirst();
    var root = findRoot();
    if (!root) return;
    var widget = root.querySelector('.yotpo-coupons-redemption-widget');
    if (!widget) return;
    var hosts = widget.querySelectorAll('.swiper-container, .yotpo-redemption-options-carousel');
    for (var i = 0; i < hosts.length; i++) {
      var swiper = hosts[i].swiper;
      if (swiper && typeof swiper.updateAutoHeight === 'function') {
        try {
          swiper.updateAutoHeight(0);
        } catch (e) {}
      } else if (swiper && typeof swiper.update === 'function') {
        try {
          swiper.update();
        } catch (e2) {}
      }
    }
  }

  function bindRedeemCardSupport() {
    var root = findRoot();
    if (!root || root.getAttribute('data-rb-redeem-card-fix') === '1') return;
    root.setAttribute('data-rb-redeem-card-fix', '1');

    /* Capture: run before Swiper's click killer */
    root.addEventListener('click', onRedeemWidgetClick, true);
    root.addEventListener('touchstart', onRedeemTouchStart, { capture: true, passive: true });
    root.addEventListener('pointerdown', onRedeemTouchStart, true);

    root.addEventListener(
      'click',
      function (event) {
        if (!event.target || !event.target.closest) return;
        if (
          !event.target.closest(
            '.yotpo-coupons-redemption-widget .yotpo-button-style, .yotpo-coupons-redemption-widget button'
          )
        ) {
          return;
        }
        window.setTimeout(refreshRedeemLayout, 0);
        window.setTimeout(refreshRedeemLayout, 120);
        window.setTimeout(refreshRedeemLayout, 400);
      },
      false
    );
  }

  var REFER_TITLE = 'Give $20, Get $20';
  var REFER_DESC =
    'Give your friends $20 off their first purchase of $40+, and get $20 off for each successful referral. Just copy your link and share!';

  function setTextIfNeeded(el, next) {
    if (!el) return;
    var cur = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (cur === next) return;
    el.textContent = next;
  }

  /* Keep How to use / Loyalty Discounts above redeem cards (rb-redeem-heading-first) */
  function ensureRedeemHeadingFirst() {
    var root = findRoot();
    if (!root) return;
    var widget = root.querySelector('.yotpo-coupons-redemption-widget');
    if (!widget) return;
    var host =
      widget.querySelector('.yotpo-coupouns-container') ||
      widget.querySelector('.yotpo-coupons-redemption-widget-container');
    if (!host) return;
    var content = host.querySelector(':scope > .yotpo-content-container') || host.querySelector('.yotpo-content-container');
    var list =
      host.querySelector(':scope > .yotpo-redemption-options-list') ||
      host.querySelector('.yotpo-redemption-options-list');
    if (!content || !list || !content.parentNode || content.parentNode !== list.parentNode) return;
    if (content.compareDocumentPosition(list) & Node.DOCUMENT_POSITION_FOLLOWING) return;
    list.parentNode.insertBefore(content, list);
  }

  function polishReferCopyButtons(sec) {
    var buttons = sec.querySelectorAll('.yotpo-copy-text-button');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', 'Copy referral link');
      btn.setAttribute('type', 'button');
      var labels = btn.querySelectorAll(
        '.yotpo-text-copied-label, .yotpo-text-copied .yotpo-customized-text, .yotpo-text-copied .yotpo-inner-text'
      );
      for (var L = 0; L < labels.length; L++) {
        setTextIfNeeded(labels[L], 'Copied!');
      }
      var copied = btn.querySelector('.yotpo-text-copied');
      if (copied) {
        var copiedText = (copied.textContent || '').replace(/\s+/g, ' ').trim();
        if (!copiedText || /^copied\.?$/i.test(copiedText)) {
          var label = copied.querySelector('.yotpo-text-copied-label, .yotpo-customized-text, .yotpo-inner-text');
          if (label) setTextIfNeeded(label, 'Copied!');
          else if (!copied.querySelector('.rb-refer-copied-label')) {
            var span = document.createElement('span');
            span.className = 'rb-refer-copied-label yotpo-text-copied-label';
            span.textContent = 'Copied!';
            copied.appendChild(span);
          }
        }
      }
    }
  }

  function polishReferWhiteBlock(sec) {
    /* Yotpo inline background-color: rgba(0,0,0,0.33) — force solid white card */
    var tiles = sec.querySelectorAll('.yotpo-tile-wrapper');
    for (var i = 0; i < tiles.length; i++) {
      tiles[i].style.setProperty('background-color', '#ffffff', 'important');
    }
  }

  /* Remove in-card "Refer a Friend" above Give/Get (rb-refer-hide-header-js) */
  function polishReferHideHeader(sec) {
    var headers = sec.querySelectorAll('.yotpo-header-text, .yotpo-login-header-text');
    for (var i = 0; i < headers.length; i++) {
      var el = headers[i];
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-rb-refer-header-hidden', '1');
    }
  }

  /*
    Logged-in desktop: force disclaimer → Refer gap to match Ways → Tiers (~70px)
    and logged-out redeem → Refer (~76). Eats leftover Yotpo dead space (rb-refer-desktop-logged-in-gap-js).
  */
  function polishReferDesktopLoggedInGap() {
    if (window.innerWidth < 1000) return;
    var root = findRoot();
    if (!root) return;
    var loggedIn =
      root.classList.contains('rb-rewards--logged-in') ||
      !!root.querySelector('.yotpo-coupons-redemption-widget-container.yotpo-logged-in');
    if (!loggedIn) return;

    var disc = root.querySelector('.rb-redeem-disclaimer');
    var sec = root.querySelector('.rewsec6');
    var referH = sec && sec.querySelector('h2, .rb-rewards__heading');
    if (!disc || !sec || !referH) return;
    if (disc.offsetHeight < 4) return;

    var TARGET = 70; /* Ways widget → Tiers heading */
    sec.style.setProperty('margin-top', '0px', 'important');
    var gap = Math.round(referH.getBoundingClientRect().top - disc.getBoundingClientRect().bottom);
    var need = TARGET - gap;
    /* Negative OK — pulls through leftover Yotpo dead space under disclaimer */
    sec.style.setProperty('margin-top', need + 'px', 'important');
    sec.setAttribute('data-rb-refer-li-gap', String(need));
  }

  /* Match Refer Join/Login pill length to hero CTAs (rb-refer-join-login-match-hero-v5) */
  function getHeroJoinLoginWidth() {
    var heroGroup =
      document.querySelector('.rewsec1 .yotpo-customer-logged-out-buttons') ||
      document.querySelector('.yotpo-widget-hero-section .yotpo-customer-logged-out-buttons');
    if (!heroGroup) return 0;
    var heroBtns = heroGroup.querySelectorAll(
      '.yotpo-register-link .yotpo-button-style, .yotpo-login-link .yotpo-button-style, .yotpo-button-style'
    );
    var max = 0;
    for (var i = 0; i < heroBtns.length; i++) {
      var w = heroBtns[i].getBoundingClientRect().width;
      if (w > max) max = w;
    }
    if (!max) max = heroGroup.getBoundingClientRect().width;
    return Math.round(max);
  }

  function polishReferJoinLoginStack(sec) {
    if (!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches)) return;
    var targetW = getHeroJoinLoginWidth();
    var widthCss = targetW > 0 ? targetW + 'px' : '11rem';
    var groups = sec.querySelectorAll('.yotpo-customer-logged-out-buttons');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      g.style.setProperty('--rb-refer-join-login-w', widthCss);
      g.style.setProperty('display', 'flex', 'important');
      g.style.setProperty('flex-direction', 'column', 'important');
      g.style.setProperty('flex-wrap', 'nowrap', 'important');
      g.style.setProperty('align-items', 'stretch', 'important');
      g.style.setProperty('justify-content', 'center', 'important');
      g.style.setProperty('width', widthCss, 'important');
      g.style.setProperty('max-width', 'none', 'important');
      g.style.setProperty('min-width', '11rem', 'important');
      g.style.setProperty('margin-left', 'auto', 'important');
      g.style.setProperty('margin-right', 'auto', 'important');
      g.style.setProperty('gap', '12px', 'important');
      g.style.setProperty('grid-template-columns', 'none', 'important');

      var wraps = g.querySelectorAll('.yotpo-register-link, .yotpo-login-link, .yotpo-action-button-widget');
      if (!wraps.length) wraps = g.children;
      for (var w = 0; w < wraps.length; w++) {
        var wrap = wraps[w];
        wrap.style.setProperty('display', 'block', 'important');
        wrap.style.setProperty('float', 'none', 'important');
        wrap.style.setProperty('width', '100%', 'important');
        wrap.style.setProperty('min-width', '0', 'important');
        wrap.style.setProperty('max-width', 'none', 'important');
        wrap.style.setProperty('margin', '0', 'important');
        wrap.style.setProperty('padding', '0', 'important');
        wrap.style.setProperty('padding-left', '0', 'important');
        wrap.style.setProperty('padding-right', '0', 'important');
        wrap.style.setProperty('box-sizing', 'border-box', 'important');
      }

      var buttons = g.querySelectorAll(
        '.yotpo-register-link .yotpo-button-style, .yotpo-login-link .yotpo-button-style, .yotpo-button-style, .yotpo-filled-button, button.yotpo-button-style'
      );
      for (var b = 0; b < buttons.length; b++) {
        buttons[b].style.setProperty('display', 'flex', 'important');
        buttons[b].style.setProperty('align-items', 'center', 'important');
        buttons[b].style.setProperty('justify-content', 'center', 'important');
        buttons[b].style.setProperty('width', '100%', 'important');
        buttons[b].style.setProperty('min-width', '11rem', 'important');
        buttons[b].style.setProperty('max-width', 'none', 'important');
        buttons[b].style.setProperty('height', '52px', 'important');
        buttons[b].style.setProperty('min-height', '52px', 'important');
        buttons[b].style.setProperty('margin', '0', 'important');
        buttons[b].style.setProperty('padding-left', '1.75rem', 'important');
        buttons[b].style.setProperty('padding-right', '1.75rem', 'important');
        buttons[b].style.setProperty('box-sizing', 'border-box', 'important');
      }

      void g.offsetWidth;
      var joinBtn = g.querySelector('.yotpo-register-link .yotpo-button-style, .yotpo-register-link button');
      var loginBtn = g.querySelector('.yotpo-login-link .yotpo-button-style, .yotpo-login-link button');
      var jw = joinBtn ? Math.round(joinBtn.getBoundingClientRect().width) : 0;
      var lw = loginBtn ? Math.round(loginBtn.getBoundingClientRect().width) : 0;
      g.setAttribute('data-rb-refer-join-login-w', jw + 'x' + lw);
      g.setAttribute('data-rb-refer-join-login-hero', String(targetW || 0));
      g.setAttribute('data-rb-refer-join-login-equal', jw && lw && jw === lw ? '1' : '0');
    }
  }

  function polishReferCopySizes(sec) {
    /* Force URL + Copy sizes — Yotpo inline can ignore stylesheet rem bumps (rb-refer-copy-bump-v2) */
    /* Mobile: Copy outside grey URL field (rb-refer-copy-outside-mobile) */
    var mobile = window.matchMedia && window.matchMedia('(max-width: 999px)').matches;
    var fieldH = mobile ? 'auto' : '80px';
    var urlFs = mobile ? '17.25px' : '20px'; /* mobile +15% */
    var pillH = mobile ? '3.25rem' : '3.25rem';
    var pillFs = mobile ? '19.2px' : '18px'; /* mobile Copy +20% */
    var pillMin = mobile ? '0' : '7rem';
    var pad = mobile ? '0' : '12px 12px 12px 22px';
    var buttons = sec.querySelectorAll('.yotpo-copy-text-button, .yotpo-main-copy-link.yotpo-copy-text-button');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (mobile) {
        btn.style.setProperty('flex-direction', 'column', 'important');
        btn.style.setProperty('align-items', 'stretch', 'important');
        btn.style.setProperty('justify-content', 'flex-start', 'important');
        btn.style.setProperty('gap', '12px', 'important');
        btn.style.setProperty('min-height', '0', 'important');
        btn.style.setProperty('height', 'auto', 'important');
        btn.style.setProperty('max-height', 'none', 'important');
        btn.style.setProperty('width', '100%', 'important');
        btn.style.setProperty('max-width', '100%', 'important');
        btn.style.setProperty('min-width', '0', 'important');
        btn.style.setProperty('overflow', 'visible', 'important');
        btn.style.setProperty('background', 'transparent', 'important');
        btn.style.setProperty('background-color', 'transparent', 'important');
        btn.style.setProperty('border', 'none', 'important');
        btn.style.setProperty('border-radius', '0', 'important');
        btn.style.setProperty('box-shadow', 'none', 'important');
      } else {
        btn.style.setProperty('flex-direction', 'row', 'important');
        btn.style.setProperty('min-height', fieldH, 'important');
        btn.style.setProperty('height', fieldH, 'important');
      }
      btn.style.setProperty('font-size', urlFs, 'important');
      btn.style.setProperty('padding', pad, 'important');
      var texts = btn.querySelectorAll('.yotpo-copy-text, .yotpo-inner-text');
      for (var t = 0; t < texts.length; t++) {
        texts[t].style.setProperty('font-size', urlFs, 'important');
        texts[t].style.setProperty('line-height', '1.35', 'important');
        if (mobile) {
          texts[t].style.setProperty('width', '100%', 'important');
          texts[t].style.setProperty('max-width', '100%', 'important');
          texts[t].style.setProperty('min-width', '0', 'important');
          texts[t].style.setProperty('white-space', 'normal', 'important');
          texts[t].style.setProperty('overflow-wrap', 'anywhere', 'important');
          texts[t].style.setProperty('word-break', 'break-word', 'important');
          texts[t].style.setProperty('order', '1', 'important');
          texts[t].style.setProperty('display', 'block', 'important');
          texts[t].style.setProperty('padding', '14px 16px', 'important');
          texts[t].style.setProperty('border-radius', '18px', 'important');
          texts[t].style.setProperty('border', '1px solid rgba(25, 57, 55, 0.16)', 'important');
          texts[t].style.setProperty('background', '#f4f5f5', 'important');
          texts[t].style.setProperty('background-color', '#f4f5f5', 'important');
          texts[t].style.setProperty('box-sizing', 'border-box', 'important');
        }
      }
      var icons = btn.querySelectorAll('.yotpo-copy-icon');
      for (var c = 0; c < icons.length; c++) {
        icons[c].style.setProperty('height', pillH, 'important');
        icons[c].style.setProperty('min-width', pillMin, 'important');
        icons[c].style.setProperty('font-size', pillFs, 'important');
        if (mobile) {
          icons[c].style.setProperty('width', '100%', 'important');
          icons[c].style.setProperty('max-width', '100%', 'important');
          icons[c].style.setProperty('align-self', 'stretch', 'important');
          icons[c].style.setProperty('order', '2', 'important');
        }
      }
      var copied = btn.querySelectorAll('.yotpo-text-copied, .yotpo-text-copied-label, .yotpo-text-copied *');
      for (var k = 0; k < copied.length; k++) {
        copied[k].style.setProperty('font-size', pillFs, 'important');
        if (copied[k].classList && copied[k].classList.contains('yotpo-text-copied')) {
          copied[k].style.setProperty('height', pillH, 'important');
          copied[k].style.setProperty('min-width', mobile ? '0' : '7.5rem', 'important');
          if (mobile) {
            copied[k].style.setProperty('width', '100%', 'important');
            copied[k].style.setProperty('max-width', '100%', 'important');
            copied[k].style.setProperty('order', '2', 'important');
          }
        }
      }
    }
  }

  function applyReferCopy() {
    var root = findRoot();
    if (!root) return;
    var sec = root.querySelector('.rewsec6');
    if (!sec) return;

    polishReferWhiteBlock(sec);
    polishReferHideHeader(sec);
    polishReferJoinLoginStack(sec);
    polishReferCopySizes(sec);
    ensureRedeemHeadingFirst();
    polishReferDesktopLoggedInGap();

    var titles = sec.querySelectorAll('.yotpo-title-text, .yotpo-login-title-text');
    for (var i = 0; i < titles.length; i++) {
      var titleEl = titles[i];
      var t = (titleEl.textContent || '').replace(/\s+/g, ' ').trim();
      if (!t || /give\s*\$?\s*20/i.test(t) || /get\s*\$?\s*20/i.test(t)) {
        /* Always strip <br> so desktop stays one line (rb-refer-give-get-oneline) */
        if (titleEl.querySelector('br') || (titleEl.textContent || '').replace(/\s+/g, ' ').trim() !== REFER_TITLE) {
          titleEl.textContent = REFER_TITLE;
        }
      }
    }

    var descs = sec.querySelectorAll('.yotpo-description-text, .yotpo-login-description-text');
    for (var d = 0; d < descs.length; d++) {
      var dt = (descs[d].textContent || '').replace(/\s+/g, ' ').trim();
      if (!dt || /friends/i.test(dt) || /referral/i.test(dt) || /\$20\s*off/i.test(dt)) {
        setTextIfNeeded(descs[d], REFER_DESC);
      }
    }

    polishReferCopyButtons(sec);
  }

  function bindReferCopy() {
    var root = findRoot();
    if (!root) return;
    applyReferCopy();
    if (root.getAttribute('data-rb-refer-copy') === '1') return;
    root.setAttribute('data-rb-refer-copy', '1');
    var sec = root.querySelector('.rewsec6');
    if (!sec || typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function () {
      applyReferCopy();
    });
    obs.observe(sec, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      try {
        obs.disconnect();
      } catch (e) {}
    }, 45000);
  }

  function bind() {
    var root = findRoot();
    if (!root) return;
    if (root.getAttribute('data-rb-redeem-now-scroll') !== '1') {
      root.setAttribute('data-rb-redeem-now-scroll', '1');
      root.addEventListener('click', onRedeemNowClick, true);
    }
    bindRedeemCardSupport();
    fixRedeemSwiperClicks();
    bindReferCopy();
    ensureRedeemHeadingFirst();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.setTimeout(bind, 500);
  window.setTimeout(bind, 2000);
  window.setTimeout(fixRedeemSwiperClicks, 3000);
  window.setTimeout(applyReferCopy, 800);
  window.setTimeout(ensureRedeemHeadingFirst, 1200);
  window.setTimeout(ensureRedeemHeadingFirst, 3500);
  window.setTimeout(applyReferCopy, 2500);
  window.setTimeout(applyReferCopy, 5000);
  window.setTimeout(applyReferCopy, 8000);
})();
